// Product page accordions: the text slides open and closed instead of jumping.
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const duration = 320;
  const easing = 'cubic-bezier(0.22, 0.61, 0.36, 1)';

  function slide(details, opening) {
    const body = details.querySelector('.collapsible-tab__text');
    if (!body) {
      details.open = opening;
      return;
    }
    body.getAnimations().forEach((animation) => animation.cancel());
    if (opening) details.open = true;
    const style = getComputedStyle(body);
    const padding = parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
    const full = body.offsetHeight - padding;
    const closed = { height: '0px', paddingBottom: '0px', opacity: 0 };
    const open = { height: `${full}px`, paddingBottom: style.paddingBottom, opacity: 1 };
    body.style.overflow = 'hidden';
    const animation = body.animate(opening ? [closed, open] : [open, closed], { duration, easing });
    animation.onfinish = () => {
      body.style.overflow = '';
      if (!opening) details.open = false;
    };
    animation.oncancel = () => {
      body.style.overflow = '';
    };
  }

  document.addEventListener('click', (event) => {
    const heading = event.target.closest('.collapsible-tab__heading');
    const details = heading?.parentElement;
    if (!details?.matches('details.collapsible-tab') || reduced.matches) return;
    event.preventDefault();
    slide(details, !details.open || details.dataset.closing === 'true' ? true : false);
  });
})();
